module.exports = __webpack_public_path__ + "static/media/create_invoice.e8dd1b3a.png";